import React from "react";
import TextField from "@material-ui/core/TextField";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { IconButton } from "@material-ui/core";
import MatUITable from "../../../components/MatUITable/MatUITable";
import Heading from "../../../components/Heading/Heading";
import LoadingIndicator from "../../../utils/LoadingIndicator/LoadingIndicator";
import ManageUsers from "../AdminUsers/ManageUsers";
function AdminUsers({ ...props }) {
  const [selectedAccount, setSelectedAccount] = React.useState(null);
  const [tableMode, setTableMode] = React.useState(true);
  const [filterBy, setFilterBy] = React.useState({
    name: "",
  });
  const handleChange = (event) => {
    setFilterBy({ ...filterBy, [event.target.id]: event.target.value });
  };
  const createTableData = (users) => {
    let rows = [];
    users.forEach((user) => {
      let match = true;
      user.name = `${user.firstname} ${user.lastname}`;
      for (let i in filterBy) {
        if (user[i] !== undefined) {
          let value = user[i].toLowerCase();
          let filter = filterBy[i].toLowerCase();
          if (filterBy[i].length !== 0 && !value.match(`${filter}`)) {
            match = false;
          }
        }
      }
      if (match) {
        rows.push(user);
      }
    });
    return rows;
  };
  return (
    <div className="AdminDashboardContent">
      {props.userAccountsFetched ? (
        <>
          {tableMode ? (
            <>
              <div className="MarginHorizontal Row">
                <TextField
                  className="MarginRight"
                  id="name"
                  placeholder="Client Name"
                  variant="outlined"
                  value={filterBy["name"]}
                  onChange={(event) => handleChange(event)}
                />
              </div>
              <Heading title="Users" />
              <MatUITable
                paging={true}
                pageSize={10}
                page="adminusers"
                onRowClick={(client) => {
                  setSelectedAccount(client);
                  setTableMode(false);
                }}
                columns={[
                  {
                    title: "Client Name",
                    field: "name",
                    align: "left",
                    defaultSort: "desc",
                  },
                  {
                    title: "Company Name",
                    field: "companyname",
                    align: "left",
                  },
                  {
                    title: "Phone",
                    field: "phone",
                    align: "left",
                  },
                  {
                    title: "Email",
                    field: "email",
                    align: "left",
                  },
                ]}
                data={createTableData(props.userAccounts)}
              />
            </>
          ) : (
            <div>
              <IconButton
                onClick={() => {
                  setTableMode(true);
                }}
                className="TransparentBlue Small MarginHorizontal"
              >
                <ArrowBackIcon />
              </IconButton>
              <ManageUsers userAccount={selectedAccount} JWT={props.JWT} />
            </div>
          )}
        </>
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
}

export default AdminUsers;
